module.exports = __webpack_public_path__ + "media/images/riders/small/JACK_MOIR-d89b2ae78081b4483588552485c38e9b.png";